module.exports = __webpack_public_path__ + "static/02-a7221c03da8695287f7ed6192df16879.jpg";